import { JobFilterFormDataSchema } from "@app/schemas/job-filter";
import { AdaptIDJobPostingSchema, JobListSchema, JobUserContextSchema } from "@app/schemas/jobs";
import { createAction, props } from "@ngrx/store";

export const setJobList = createAction(
  'Job List Created',
  props<{ jobs: JobListSchema[] }>(),
);

export const updateUserJobFilterOptions = createAction(
  'Update User Job Filter Options',
  props<{ filter: JobFilterFormDataSchema }>(),
);

export const setAdeptIDJobPostings = createAction(
  'Set AdeptID Job Postings',
  props<{ jobs: AdaptIDJobPostingSchema[] }>(),
);

export const updateJobSortByOption = createAction(
  'Update Job Sort By Option',
  props<{ sortBy: string }>(),
);

export const updateJobUserContext = createAction(
  'Update Job User Context',
  props<{ userContext: JobUserContextSchema }>(),
);

export const addGeneratedJobId = createAction(
  'Add Generated Job ID',
  props<{ jobId: string }>(),
);